export enum FontSize {
  xs = "text-xs",
  sm = "text-sm",
  base = "text-base",
  lg = "text-lg",
  xl = "text-xl",
  "2xl" = "text-2xl",
  "3xl" = "text-3xl",
  "4xl" = "text-4xl",
  "5xl" = "text-5xl",
  "md:text-xs" = "md:text-xs",
  "md:text-sm" = "md:text-sm",
  "md:text-base" = "md:text-base",
  "md:text-lg" = "md:text-lg",
  "md:text-xl" = "md:text-xl",
  "md:text-2xl" = "md:text-2xl",
  "md:text-3xl" = "md:text-3xl",
  "md:text-4xl" = "md:text-4xl",
  "md:text-5xl" = "md:text-5xl",
}
